import { createContext } from 'react'

import types from './types'

export const initialState = {
  token: null,
  clubUserAgreementId: null,
  userData: {
    signedBy: '',
    signedEmail: '',
    phone: '',
    agreed: 0,
    countryCode: 'AU',
    createBookings: false,
    clubId: null,
  },
  loading: false,
  loadingClub: false,
  clubData: {},
  agreementContent: '',
  agreementVisible: false,
  workoutModalVisible: false,
  gmbPlaceId: null,
  customTriggered: false,
}

export const reducer = (state, action) => {
  switch (action.type) {
    case types.UPDATE_TOKEN: {
      return {
        ...state,
        token: action.payload,
      }
    }
    case types.UPDATE_USER_DATA: {
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.payload,
        },
      }
    }
    case types.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      }
    }
    case types.UPDATE_AGREEMENT_ID: {
      return {
        ...state,
        clubUserAgreementId: action.payload,
      }
    }
    case types.SET_CLUB_LOADING: {
      return {
        ...state,
        loadingClub: action.payload,
      }
    }
    case types.SET_CLUB_DATA: {
      return {
        ...state,
        clubData: action.payload,
      }
    }
    case types.SET_AGREEMENT_CONTENT: {
      return {
        ...state,
        agreementContent: action.payload,
      }
    }
    case types.TOGGLE_AGGREEMENT: {
      return {
        ...state,
        agreementVisible: !state.agreementVisible,
      }
    }
    case types.TOGGLE_WORKOUT_MODAL: {
      return {
        ...state,
        workoutModalVisible: !state.workoutModalVisible,
      }
    }
    case types.SET_CUSTOM_TRIGGER: {
      return {
        ...state,
        customTriggered: action.payload,
      }
    }
    default:
      return state
  }
}

export const Context = createContext()
